import { useRef, useState } from 'react';

export const usePausableStory = () => {
  const [pause, setPause] = useState(false);
  const touchTimeout = useRef<NodeJS.Timeout | null>(null);

  const handlePause = (value: boolean) => {
    if (touchTimeout.current) clearTimeout(touchTimeout.current);

    touchTimeout.current = setTimeout(() => {
      setPause(value);
    }, 100);
  };

  return {
    pause,
    handleOnPause: () => handlePause(true),
    handleOnUnpause: () => handlePause(false),
  };
};
